import { motion } from 'framer-motion'
import { Quote, Star } from 'lucide-react'

const testimonials = [
  {
    quote: "Needed our new store fully set up before opening day — CCTV, alarms, PA system, POS, the works. Akshay had everything running the day before we opened. Not one thing missing, not one delay.",
    author: "Gurjit Singh",
    company: "Sadar Bazaar — Punjab Imports",
    service: "IT Store Setup",
    initials: "GS",
  },
  {
    quote: "We wanted customers to order from their phones without having to download an app. Akshay built exactly that — went live within a few weeks. Our staff love it, our customers love it, and orders are up.",
    author: "Management",
    company: "Majnu Shisha Bar & Lounge",
    service: "Digital Ordering App",
    initials: "MJ",
  },
  {
    quote: "Four stores, one IT person. When something breaks — and it always eventually does — Akshay is on it within the hour. I genuinely wouldn't run our operations without him in the background.",
    author: "Operations Manager",
    company: "Melbourne Supermarket Group",
    service: "Managed IT Support",
    initials: "OM",
  },
]

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-16 md:py-24 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">

        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} transition={{ duration: 0.5 }}
          className="flex items-center gap-3 mb-4">
          <span className="font-mono text-[#0047AB] text-xs tracking-[0.3em] uppercase">Client Feedback</span>
          <span className="h-px flex-1 max-w-[60px] bg-[#0047AB]/25" />
        </motion.div>

        <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.05 }}
          className="font-sans font-bold text-4xl md:text-5xl tracking-tight text-[#111111] mb-10 md:mb-12">
          What clients say.
          <br /><span className="text-[#6B7280]">In their own words.</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <TestimonialCard key={i} testimonial={t} index={i} />
          ))}
        </div>
      </div>
    </section>
  )
}

function TestimonialCard({ testimonial, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-40px' }}
      transition={{ duration: 0.55, delay: index * 0.08 }}
      className="group flex flex-col bg-white border border-[#E5E7EB] rounded-2xl p-6 shadow-card hover:shadow-card-hover hover:border-[#0047AB]/20 transition-all duration-300"
      data-testid={`testimonial-card-${index}`}
    >
      {/* Stars */}
      <div className="flex items-center gap-0.5 mb-5">
        {[...Array(5)].map((_, i) => (
          <Star key={i} size={12} className="text-[#0047AB] fill-[#0047AB]" />
        ))}
      </div>

      {/* Quote */}
      <blockquote className="font-body text-[#374151] text-sm leading-relaxed flex-1 mb-6 relative">
        <Quote size={20} className="text-[#0047AB]/20 absolute -top-1 -left-1" />
        <span className="relative z-10">{testimonial.quote}</span>
      </blockquote>

      {/* Author */}
      <div className="flex items-center gap-3 pt-4 border-t border-[#F3F4F6]">
        {/* Avatar initials */}
        <div className="w-9 h-9 rounded-full bg-[#EBF2FF] border border-[#0047AB]/15 flex items-center justify-center shrink-0">
          <span className="font-mono text-[#0047AB] text-xs font-bold">{testimonial.initials}</span>
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-sans font-semibold text-[#111111] text-sm leading-tight">{testimonial.author}</div>
          <div className="font-body text-[#9CA3AF] text-xs truncate">{testimonial.company}</div>
        </div>
        <span className="shrink-0 px-2 py-0.5 bg-[#F3F4F6] border border-[#E5E7EB] text-[#6B7280] text-[9px] font-mono rounded-md">
          {testimonial.service}
        </span>
      </div>
    </motion.div>
  )
}
